export const COMPOSITIONS_FETCH = 'fetchCompositions';
export const COMPOSITIONS_SHOW = 'showCompositions';
export const COMPOSITIONS_HIDE = 'hideCompositions';
export const COMPOSITIONS_SAVE = 'saveComposition';
export const COMPOSITIONS_DELETE = 'deleteComposition';
export const COMPOSITIONS_REVERT_CHANGES = 'compositionsRevertChanges';
export const COMPOSITIONS_LAYER_CHANGED = 'compositionsLayerChanged';

export const LAYERS_DELETE = 'deleteLayer';

export const STYLES_SAVE = 'saveStyle';
export const STYLES_DELETE = 'deleteStyle';
export const STYLES_FETCH = 'fetchStyles';

export const FEATURES_SHOW_ON_MAP = 'featuresShowOnMap';
export const FEATURES_FETCH = 'fetchFeatures';
export const FEATURES_GEOMETRY_ANALYSIS = 'featuresGeometryAnalysis';
export const FEATURES_PROXIMITY_ANALYSIS = 'featuresProximityAnalysis';
export const FEATURES_NEAREST_ANALYSIS = 'featuresNearestAnalysis';
export const FEATURES_SELECTED_MAP_ITEM = 'featuresSelectedMapItem';
export const FEATURES_GET_IMPORTED_COUNT = 'featuresGetImportedCount';

export const MAP_CURRENT_VIEW_SET = 'setCurrentView';
export const MAP_PREVIOUS_VIEW_MOVE = 'moveToPreviousView';
export const MAP_NEXT_VIEW_MOVE = 'moveToNextView';

export const KEYSHORTCUTS_FETCH = 'fetchKeyShortcuts';

export const TOOLS_FETCH = 'fetchTools';

export const EDIT_SESSION_START = 'editSessionStart';
export const EDIT_SESSION_END = 'editSessionEnd';
export const EDIT_SESSION_ADD_FEATURE = 'editSessionAddFeature';
export const EDIT_SESSION_DELETE_FEATURE = 'editSessionRemoveFeature';
export const EDIT_SESSION_EDIT_FEATURE = 'editSessionEditFeature';
export const EDIT_SESSION_EDIT_FEATURES = 'editSessionEditFeatures';
export const EDIT_SESSION_COPY_FEATURES = 'editSessionCopyFeatures';
export const EDIT_SESSION_FOCUS_ON_FEATURE = 'editSessionShowFeature';
export const EDIT_SESSION_GET_FEATURE_BY_ID = 'editSessionGetFeatureById';
export const EDIT_SESSION_VALIDATE_FEATURES = 'editSessionValidateFeatures';
export const EDIT_SESSION_GET_FEATURE_GEOMETRY =
  'editSessionGetFeatureGeometry';
export const EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY =
  'editSessionTransformGeometryToFeatureGeometry';
export const EDIT_SESSION_CREATE_NEW_FEATURE_FROM_COPIED_FEATURE =
  'editSessionCreateNewFeatureFromCopiedFeature';
export const EDIT_SESSION_RESTORE_DEFAULT_SETTINGS =
  'editSessionRestoreDefaultSettings';
export const EDIT_SESSION_APPLY_MULTISELECT_MODIFICATATION =
  'editSessionApplyMultiselectModification';
// export const EDIT_SESSION_COPY_FEATURE = 'editSessionCopyFeature';

export const RESET_FOCUSED_FEATURE_ID = 'resetFocusedFeatureId';

export const REPORTS_SAVE = 'saveReport';

export const REPORT_VALIDATION = 'validateReport';
export const REPORT_PUBLICATION = 'publishReport';
export const REPORT_PUBLICATION_SCHEDULE_BREAK_ACTIVE =
  'reportPublicationScheduleBreak';
export const REPORT_GET_EDIT_SESSION = 'getEditSessionForReport';
export const REPORT_CANCEL_DATA_FEED = 'cancelDataFeed';

export const CLAUSES_FETCH = 'fetchClauses';

export const TEMPORARY_LAYER_SAVE = 'saveTemporaryLayer';
export const TEMPORARY_LAYER_SAVE_NAME = 'saveTemporaryLayerName';
export const TEMPORARY_LAYER_ADD = 'addTemporaryLayer';
export const TEMPORARY_LAYER_TOGGLE_VISIBILITY =
  'toggleTemporaryLayerVisibility';
export const BEGIN_POLE_ANALYSIS = 'beginPoleAnalysis';
export const CANCEL_POLE_ANALYSIS = 'cancelPoleAnalysis';
export const CALCULATE_POLE_ANALYSIS = 'calculatePoleAnalysis';
export const MEASUREMENTS_LAYER_ADD_OR_GET = 'addOrGetMeasurementsLayer';
export const TEMPORARY_LAYER_REMOVE = 'removeTemporaryLayer';
export const OTHER_TEMPORARY_LAYER_ADD = 'addTemporaryDecisionLayer';

export const SEARCH_LAYER_ADD_OR_EDIT = 'addOrEditSearchLayer';
export const MILEAGE_SEARCH_LAYER_ADD = 'addMileageSearchLayer';
export const MILEAGE_SEARCH_LAYER_APPEND_FEATURES =
  'appendFeaturesToMileageSearchLayer';
export const TERYT_SEARCH_LAYER_ADD = 'addTerytSearchLayer';
export const TERYT_SEARCH_LAYER_APPEND_FEATURES =
  'appendFeaturesToTerytSearchLayer';

export const METADATA_EXTENT_LAYER_ADD_OR_CHANGE =
  'metadataExtentLayerAddOrChange';

export const SPATIAL_TABS_SHOW_MODAL = 'spatialTabsShowModal';
export const SPATIAL_TABS_POST_TAB = 'postSpatialTab';
export const SPATIAL_TABS_FETCH = 'fetchSpatialTabs';
export const SPATIAL_TABS_DELETE = 'deleteSpatialTab';
export const SPATIAL_TABS_PUT_TAB = 'putSpatialTab';
export const SPATIAL_TABS_GOTO = 'spatialTabsGoto';

export const MEASUREMENTS_ENABLE = 'enableMeasurements';

export const MAP_SELECTION_APPLY = 'applyMapSelection';
export const SINGLE_CLICK_SELECTION_APPLY = 'applySingleClickSelection';
export const EXTENT_SELECTION_APPLY = 'applyExtentSelection';
export const SELECT_MODE_TOGGLE = 'toggleSelectMode';
export const MAP_SELECTION_CLEAR = 'clearMapSelection';
export const EXTENT_SELECTION_START = 'startExtentSelection';
export const EDIT_SESSION_GET_OBJECTS_FROM_MAP_SELECTED =
  'SearchSelectedObjectsWfsGet';

export const SEARCH_MILEAGE_GET = 'getMileageSearchResult';
export const SEARCH_ROAD_GET = 'getRoadSearchResult';
export const SEARCH_TERYT_GET = 'getTerytSearchResult';
export const SEARCH_TERYTPARCEL_GET = 'getTerytParcelSearchResult';
export const SEARCH_ADDRESS_GET = 'getAddressSearchResult';
export const SEARCH_COORDINATE_GET = 'getCoordinateSearchResult';
export const SEARCH_COORDINATE_FOR_ADDRESS_GET =
  'getCoordinateForAddressSearch';
export const SEARCH_OBJECTS_WFS_GET = 'getObjectsWfs';
export const PUBLISH_DEMAND = 'publishDemand';
export const EXPORT_DEMAND = 'exportDemand';

export const ADD_FEATURE_POINT = 'addFeaturePoint';
export const ADD_FEATURE_POINT_MANUALLY = 'addFeaturePointManually';
export const POINT_CHANGED = 'pointChanged';
export const DELETE_POINT = 'deletePoint';

export const RESPONSIVENESS_MANAGER_TRIGGER = 'triggerResponsivenessManager';
export const BEGIN_ROAD_LANE_ANALYSIS = 'beginRoadLaneAnalysis';
export const STOP_ROAD_LANE_ANALYSIS = 'stopRoadLaneAnalysis';
export const ROAD_LANE_FEATURE_ADD_POINT = 'roadLaneFeatureAddPoint';
export const ROAD_LANE_FEATURE_END_DRAWING = 'roadLaneFeatureEndDrawing';
export const ROAD_LANE_GENERATE_REPORT = 'roadLaneGenerateReport';

export const CONNECTION_GENERATE_REPORT = 'connectionGenerateReport';
export const HISTORY_GET_OBJECTS = 'getHistoryObjects';
export const HISTORY_GET_OBJECT = 'getHistoryObject';

export const MISMATCH_SAVE = 'saveMismatch';
export const READ_ONLY_GET = 'getReadOnly';

export const BEGIN_SET_FEATURE_GEOMETRY = 'beginSetFeatureGeometry';
export const END_SET_FEATURE_GEOMETRY = 'endSetFeatureGeometry';
export const START_SET_FEATURE_GEOMETRY = 'startSetFeatureGeometry';
export const SET_FEATURE_GEOMETRY_ADD_POINT =
  'setFeatureGeometryFeatureAddPoint';
export const SET_FEATURE_GEOMETRY_END_DRAWING = 'setFeatureGeometryEndDrawing';
export const SET_FEATURE_SAVE_GEOMETRY = 'setFeatureSaveGeometry';

export const TOGGLE_GET_FEATURE_INFO = 'toggleGetFeatureInfo';
export const TOGGLE_REPORT_DEMAND = 'toggleReportDemand';
export const TOGGLE_OBJECT_DETAILS_STATE = 'toggleObjectDetailsState';
export const WMS_GET_FEATURE_INFO = 'wmsGetFeatureInfo';
export const SET_GET_FEATURE_INFO_LAYER = 'setGetFeatureInfoLayer';
export const CANCEL_GET_FEATURE_INFO = 'cancelGetFeatureInfo';

export const TOGGLE_ACTIVE_LAYER = 'toggleActiveLayer';
export const ACTIVATE_LAYER = 'setActiveLayer';
export const DEACTIVATE_LAYERS = 'deactivateLayers';

export const DECISION_FETCH = 'showDecision';

export const FETCH_ALL_LAYERS = 'fetchAllLayers';
export const FETCH_BACKGROUND_LAYERS = 'fetchBackgroundLayers';
export const MAKE_BACKGROUND_LAYER_VISIBLE = 'makeBackGroundLayerVisible';
export const APPLY_ALL_LAYERS_VISIBILITY = 'applyLayersVisibility';

export const VIEW_SETTINGS_SAVE = 'saveViewSettings';
export const VIEW_SETTINGS_LOAD = 'loadViewSettings';
export const VIEW_SETTINGS_CLEAR = 'clearViewSettings';

export const RESPONSIVE_VERSION_CHECK_IF_MOBILE =
  'checkIfMobileResponsiveVersion';

export const DISPLAY_CONTEXT_ASSISTANT_MESSAGE =
  'displayContextAssistantMessage';
export const HIDE_CONTEXT_ASSISTANT_MESSAGE = 'hideContextAssistantMessage';

export const INVENTARIZATION_LAYERS_CREATE = 'createInventarizationLayers';
export const INVENTARIZATION_LAYERS_SHOW = 'showInventarizationLayers';
export const INVENTARIZATION_LAYERS_HIDE = 'hideInventarizationLayers';
export const CHANGE_INVENTARIZATION_LAYERS_HEADERS =
  'changeInventarizationLayersHeaders';
export const REDRAW_INVENTARIZATION_LAYERS =
  'redrawInventarizationLayersHeaders';

export const SESSION_TIMER_START = 'sessionTimerStart';
export const SESSION_TIMER_RESET = 'sessionTimerReset';
export const SESSION_TIMER_STOP = 'sessionTimerStop';
